import { BaseAction } from "../actions/base-actions";

export const REHYDRATE =            "[Rehydrate] Rehydrate";
export const REHYDRATE_DEMO =       "[Rehydrate] Rehydrate Demo";
export const REHYDRATE_SUCCESS =    "[Rehydrate] Rehydrate Success";
export const REHYDRATE_FAIL =       "[Rehydrate] Rehydrate Fail";

export class RehydrateAction extends BaseAction {
    readonly type = REHYDRATE;

    constructor() {
        super(undefined, {restful: false, persistable: false});
    }
}

export class RehydrateDemoAction extends BaseAction {
    readonly type = REHYDRATE_DEMO;

    constructor(payload) {
        super(payload, {restful: false, persistable: false});
    }
}

export class RehydrateSuccessAction extends BaseAction {
    readonly type = REHYDRATE_SUCCESS;

    constructor() {
        super(undefined, {restful: false, persistable: false});
    }
}

export class RehydrateFailAction extends BaseAction {
    readonly type = REHYDRATE_FAIL;

    constructor(error: Error) {
        super(error, {restful: false, persistable: false});
    }
}

export type Actions
    = RehydrateAction
    | RehydrateSuccessAction
    | RehydrateFailAction;



// WEBPACK FOOTER //
// ./src/core/store/hydrator/rehydrate.actions.ts